'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestSKU = undefined;

var _MerchandiseIdsToUpgradeProducts = require('self-service-api/constants/MerchandiseIdsToUpgradeProducts');

var _requestNotificationsApi = require('ui-addon-upgrades/_core/common/api/requestNotificationsApi');

var _tracker = require('ui-addon-upgrades/_core/common/eventTracking/tracker');

var tracker = _interopRequireWildcard(_tracker);

var _wrapWithErrorMonitoring = require('ui-addon-upgrades/_core/common/reliability/wrapWithErrorMonitoring');

var _wrapWithErrorMonitoring2 = _interopRequireDefault(_wrapWithErrorMonitoring);

var _getUpgradeLink = require('ui-addon-upgrades/_core/common/adapters/getUpgradeLink');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var requestSKU = exports.requestSKU = (0, _wrapWithErrorMonitoring2.default)('requestSKU', function (_ref) {
  var merchandiseId = _ref.merchandiseId,
      productName = _ref.productName;

  var cta = (0, _getUpgradeLink.getUpgradeLink)({
    source: 'admin-sku-request',
    upgradeProduct: _MerchandiseIdsToUpgradeProducts.MerchandiseIdsToUpgradeProducts[merchandiseId]
  });
  return (0, _requestNotificationsApi.sendRequestSKUNotification)(productName, cta).then(function () {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('requestUpgradeInteraction', {
      action: 'request sku notification succeeded',
      merchandiseId: merchandiseId
    });
  }).catch(function (e) {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('requestUpgradeInteraction', {
      action: 'request sku notification failed',
      merchandiseId: merchandiseId
    });

    if (window.Raven) {
      window.Raven.captureMessage('Request sku notification failed', {
        extra: { error: e }
      });
    }
  });
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/upgrade/requestSKU.js
// module id = 512
// module chunks = 3 4 5